import { render, staticRenderFns } from "./excelSelector.vue?vue&type=template&id=6835b2b8&"
import script from "./excelSelector.vue?vue&type=script&lang=js&"
export * from "./excelSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports